import { VIPTable, PutVIPForm } from "../components/VIPComponents"
import { useState, useEffect, useContext } from "react"
import { AuthContext } from '../contexts/AuthContext';
import axios from "axios";
import { responseHandler } from "../components/utility/Utility";
import { InitiateTutorial } from "../components/Onboarding";
import { useSearchParams } from "react-router-dom";

export default function VIP() {
  const {logout, getJwtToken} = useContext(AuthContext);
  const [vip, setVip] = useState(false);
  const [formValues, setFormValues] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [integrated, setIntegrated] = useState(true);
  const [tutorial, setTutorial] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const fetchVipData = async () => {
        const tutorial = searchParams.get('tutorial');
        if (tutorial === 'true') setTutorial(1);
        try {
            const token = await getJwtToken();
            const res = await axios.get('https://api.amplifyloyalty.com/app/stores/vip', {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (res.data.name === 'BadRequestError') {
                logout();
            } else {
                const isIntegrated = res.headers['x-integrated'];
                if (isIntegrated == 'false') setIntegrated(false);
                setVip(res.data);
            }
        } catch (err) {
            console.log(err);
            responseHandler(err);
        }
    };

    fetchVipData();
  }, []);

  return (
    <div className="main two-column">
      {tutorial === 1 && 
        <InitiateTutorial 
          text="In this guide, you will learn how to create and customize your VIP tiers."
          header="VIP Setup" 
          setTutorial={setTutorial}
        />
      }
      <div className="vip-row">
        <VIPTable 
          vip={[vip, setVip]} 
          formValues={[formValues, setFormValues]} 
          tutorial={tutorial}
          setTutorial={setTutorial}
        />
        {formValues && 
          <PutVIPForm 
            vip={[vip, setVip]} 
            formValues={[formValues, setFormValues]} 
            isEditing={[isEditing, setIsEditing]} 
            notIntegrated={!integrated}
            tutorial={tutorial}
            setTutorial={setTutorial}
          /> 
        }
      </div>
    </div>
  )
}
